module.exports = __webpack_public_path__ + "img/desktop-locked.6bbf4726.png";